"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Auth_Nav_Actions } from "@/components/auth/auth-nav-actions";
import { Nav_Links } from "@/lib/sovereign-core/content";
import { Logo_Mark } from "./logo-mark";

export function Site_Nav() {
  const Path_Current = usePathname();

  return (
    <header className="sticky top-0 z-50 border-b border-pq-border bg-pq-bg/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-5 py-3 sm:gap-4">
        <Link href="/" className="group flex min-w-0 shrink items-center gap-2 sm:gap-3">
          <Logo_Mark ClassName="h-9 w-9 shrink-0 transition-transform group-hover:scale-105" />
          <span className="font-display truncate text-sm font-semibold tracking-[0.18em] text-pq-fg uppercase">
            Parcel Q
          </span>
        </Link>

        <nav className="hidden min-w-0 flex-1 items-center justify-center gap-1 lg:flex" aria-label="Main">
          {Nav_Links.map((Link_Item) => {
            const Is_Active = Path_Current === Link_Item.Href;

            return (
              <Link
                key={Link_Item.Href}
                href={Link_Item.Href}
                className={`rounded-md px-3 py-2 text-sm font-medium underline-offset-4 transition-colors ${
                  Is_Active
                    ? "bg-pq-bg-soft text-amber-950 underline decoration-amber-600 dark:text-amber-100"
                    : "text-pq-fg-muted hover:bg-pq-bg-soft hover:text-amber-950 hover:underline dark:hover:text-amber-100"
                }`}
              >
                {Link_Item.Label}
              </Link>
            );
          })}
        </nav>

        <div className="ml-auto shrink-0">
          <Auth_Nav_Actions />
        </div>
      </div>

      <nav
        className="flex gap-1 overflow-x-auto border-t border-pq-border/50 px-3 py-2 lg:hidden"
        aria-label="Main mobile"
      >
        {Nav_Links.map((Link_Item) => {
          const Is_Active = Path_Current === Link_Item.Href;

          return (
            <Link
              key={Link_Item.Href}
              href={Link_Item.Href}
              className={`shrink-0 rounded-full px-3 py-1.5 text-xs font-medium whitespace-nowrap ${
                Is_Active
                  ? "bg-pq-bg-soft text-amber-950 dark:text-amber-100"
                  : "text-pq-fg-muted"
              }`}
            >
              {Link_Item.Label}
            </Link>
          );
        })}
      </nav>
    </header>
  );
}
